import { post } from '@/utilities/onwardClient';
import { ORDERS_EXPORT_CSV } from '@/constants/apiRoutes';

export const exportCsv = async ({ query }) => {
    return post(ORDERS_EXPORT_CSV, {
        type: 'ORDER_LOADBOARD',
        query,
    });
};
